import { LitElement, css, html } from 'lit';
import { property, customElement } from 'lit/decorators.js';

/*
import { resolveRouterPath } from '../router';

import { axios } from '@bundled-es-modules/axios/index.js';
import { format} from 'date-fns';
//import bootstrap from 'bootstrap';
*/

//import  { bs }  from '../styles/bootstrap.css';
import  { astro }  from '../styles/astro_base.css';
import bsicon  from '../styles/bootstrap-icons/bootstrap-icons.css.js';


@customElement('app-home')
export class AppHome extends LitElement {

  @property() message = 'Welcome!';

	// @ts-ignore
  static styles = [
    bsicon, astro,
    css`
  `];

  async firstUpdated() {
    console.log('This is your home page');
  }


  render() {
    return html`



      <header class="sticky top-0 z-50 w-full border-b border-gray-200 bg-white/80 backdrop-blur-lg transition-all dark:border-gray-800 dark:bg-gray-950/80" data-header>
         <div class="container mx-auto flex h-16 items-center justify-between px-4 lg:h-20 lg:px-8">
						SmarterStack.dev
						<a href="https://smarterstack.dev/" data-nav-link="/about" class="text-sm font-medium text-gray-600 transition-colors hover:text-gray-900 dark:text-gray-400 dark:hover:text-white"> Home </a>
						<a href="/blog/" data-nav-link="spaces" class="text-sm font-medium text-gray-600 transition-colors hover:text-gray-900 dark:text-gray-400 dark:hover:text-white"> Blog </a>
							<button type="button" data-mobile-toggle class="rounded-lg p-2 text-gray-600 transition-colors hover:bg-gray-100 lg:hidden dark:text-gray-400 dark:hover:bg-gray-800" aria-label="Open menu" aria-expanded="false">
								<svg class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
										<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16"></path>
								</svg>
							</button>
							<a href="index.html#contact" class="hidden rounded-lg bg-primary-600 px-5 py-2.5 text-sm font-medium text-white transition-colors hover:bg-primary-700 sm:inline-flex">
								Contact Me
							</a> <!-- Mobile Menu Button -->
         </div>
      </header>




      <main>







		<section class="relative overflow-hidden bg-gradient-to-b from-primary-50 to-white dark:from-gray-900 dark:to-gray-950">
			<!-- Decorative blobs -->
			<div class="absolute inset-0 -z-10 overflow-hidden" aria-hidden="true">
					<div class="animate-hero-float absolute -top-40 left-1/2 h-[500px] w-[500px] -translate-x-1/2 rounded-full bg-primary-200/50 blur-3xl dark:bg-primary-900/30" data-parallax="0.15"></div>
					<div class="animate-hero-float-reverse absolute right-0 top-0 h-[400px] w-[400px] rounded-full bg-primary-100/40 blur-3xl dark:bg-primary-800/20" data-parallax="-0.1"></div>
			</div>
			<div class="container mx-auto px-4 py-20 lg:px-8 lg:py-32">
				<div class="mx-auto max-w-4xl text-center">

					<h1 style="font-family: Plus Jakarta Sans, system-ui, sans-serif;" class="text-4xl font-bold tracking-tight text-gray-900 sm:text-5xl lg:text-6xl dark:text-white" data-animate="fade-in-up" data-delay="100">
						Simplify Developer
						<br >
						<span style="color:#d97706;margin-top:10px;">
							Onboarding.
						</span>
					</h1>
					<p class="mx-auto mt-6 max-w-2xl text-lg text-gray-600 sm:text-xl dark:text-gray-400" data-animate="fade-in-up" data-delay="200">
						Most developers should reach
						<span style="font-size:22px;;font-weight:bold;"><u>first success < 10 minutes.</u></span>
						<br/>
						<img src="/assets/ItWorksTerminal.png" style="margin: auto;margin-top:20px;margin-bottom:20px;"/>
						I help developer platforms get users from
						<span style="font-size:22px;;font-weight:bold;">
							signup to
						</span>

						<span style="font-size:22px;font-weight:bold;color:#d97706;">
						“<u>I get it!</u>”
						</span>
					</p>
				</div>
			</div>




			<div class="mx-auto max-w-3xl text-center " style="margin-top:-30px;">
				<div class="mb-4 inline-flex items-center rounded-full bg-primary-100 px-3 py-1 text-sm font-medium text-primary-700 dark:bg-primary-900/50 dark:text-primary-300" data-animate="fade-in-up">
					The Problem
				</div>
				<h3 style="text-align:left;margin-left:50px;" class="text-3xl font-bold tracking-tight text-gray-900 sm:text-3xl dark:text-white" data-animate="fade-in-up" data-delay="100">
					Where Developers Usually Drop Off
				</h3>
				<p  class="mt-4 text-lg text-gray-600 dark:text-gray-400" data-animate="fade-in-up" data-delay="200">
				<ul style="text-align:left;margin-left:50px;" class="mt-4 text-lg text-gray-600 dark:text-gray-400">
					<li>Your quickstart looks right but <i>breaks in reality</i></li>
					<li>Time-to-first-success is <i>too long</i></li>
					<li>Docs <i>don’t match</i> actual setup</li>
					<li>Example projects are <i>missing or don't work</i></li>
					<li>Local dev setup is <i>painful</i></li>
				</ul>
				</p>
			</div>






			<div class="mx-auto max-w-3xl text-center " style="margin-top:50px;">
				<div class="mb-4 inline-flex items-center rounded-full bg-primary-100 px-3 py-1 text-sm font-medium text-primary-700 dark:bg-primary-900/50 dark:text-primary-300" data-animate="fade-in-up">
					<!-- What I Do -->
					 Find the Drop-Offs
				</div>
				<h3 style="text-align:left;margin-left:50px;" class="text-3xl font-bold tracking-tight text-gray-900 sm:text-3xl dark:text-white" data-animate="fade-in-up" data-delay="100">
					<!--I go through your product like a new developer and find exactly where they drop off.-->
					See What Developers See
				</h3>
				<p  class="mt-4 text-lg text-gray-600 dark:text-gray-400" data-animate="fade-in-up" data-delay="200">
				<ul style="text-align:left;margin-left:50px;" class="mt-4 text-lg text-gray-600 dark:text-gray-400">
					<li>Quickstart + docs that <i>make it easy</i></li>
					<li>Build real example apps that are <i>exciting</i></li>
					<li><i>Reduce setup</i> + DevOps friction</li>
					<li>Onboarding teardown <i>(real user perspective)</i></li>
					<li>Improve <i>time-to-first-success</i></li>
				</ul>
				</p>
			</div>





			<div class="mx-auto max-w-3xl text-center " style="margin-top:50px;">
				<div class="mb-4 inline-flex items-center rounded-full bg-primary-100 px-3 py-1 text-sm font-medium text-primary-700 dark:bg-primary-900/50 dark:text-primary-300" data-animate="fade-in-up">
					Why Me
				</div>
				<h3 style="text-align:left;margin-left:50px;" class="text-3xl font-bold tracking-tight text-gray-900 sm:text-3xl dark:text-white" data-animate="fade-in-up" data-delay="100">
					I am *<u>not</u>* a marketer.
				</h3>
				<p  class="mt-4 text-lg text-gray-600 dark:text-gray-400" data-animate="fade-in-up" data-delay="200">
				<ul style="text-align:left;margin-left:50px;" class="mt-4 text-lg text-gray-600 dark:text-gray-400">
					<li>SaaS founder</li>
					<li>Software developer</li>
					<li>DevOps engineer</li>
					<li>Built and run real systems from ground up</li>
					<li>Author of The Super Landlord</li>
				</ul>
				</p>
			</div>




			<div class="mx-auto max-w-3xl text-center " style="margin-top:50px;">
				<div class="mb-4 inline-flex items-center rounded-full bg-primary-100 px-3 py-1 text-sm font-medium text-primary-700 dark:bg-primary-900/50 dark:text-primary-300" data-animate="fade-in-up">
					Get A Teardown
				</div>
				<h3 style="text-align:left;margin-left:50px;" class="text-3xl font-bold tracking-tight text-gray-900 sm:text-3xl dark:text-white" data-animate="fade-in-up" data-delay="100">
					See Where Developers Get Stuck
				</h3>
				<p style="text-align:left;margin-left:50px;" class="mt-4 text-lg text-gray-600 dark:text-gray-400">
					I approach developer onboarding like a new user would — signing up, trying the quickstart, and identifying where developers get stuck.
				</p>
				<p  class="mt-4 text-lg text-gray-600 dark:text-gray-400" data-animate="fade-in-up" data-delay="200">
							<a href="#contact" class="inline-flex items-center justify-center gap-2 rounded-lg bg-primary-600 px-6 py-3 text-base font-medium text-white shadow-lg shadow-primary-600/25 transition-all hover:bg-primary-700 hover:shadow-xl hover:shadow-primary-600/30">
								<> Get My Teardown
							</a>

				</p>
			</div>


		</section>

</main>

<!--

									<div class="mt-10 flex flex-col items-center justify-center gap-4 sm:flex-row" data-animate="fade-in-up" data-delay="300">
                     <a href="#contact" class="inline-flex items-center justify-center gap-2 rounded-lg bg-primary-600 px-6 py-3 text-base font-medium text-white shadow-lg shadow-primary-600/25 transition-all hover:bg-primary-700 hover:shadow-xl hover:shadow-primary-600/30">
                        Book a Free Tour
                        <svg class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                           <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 8l4 4m0 0l-4 4m4-4H3"></path>
                        </svg>
                     </a>
                     <a href="#pricing" class="inline-flex items-center justify-center gap-2 rounded-lg border border-gray-300 bg-white px-6 py-3 text-base font-medium text-gray-700 transition-colors hover:bg-gray-50 dark:border-gray-700 dark:bg-gray-900 dark:text-gray-300 dark:hover:bg-gray-800"> View Plans </a>
                     <button type="button" data-video-modal="https://www.youtube.com/embed/dQw4w9WgXcQ" class="inline-flex items-center gap-3 text-sm font-medium text-gray-700 transition-colors hover:text-primary-600 dark:text-gray-300 dark:hover:text-primary-400">
                        <span class="flex h-12 w-12 items-center justify-center rounded-full bg-primary-600 text-white shadow-lg shadow-primary-600/25 transition-all hover:shadow-xl hover:shadow-primary-600/30">
                           <svg class="ml-0.5 h-5 w-5" fill="currentColor" viewBox="0 0 24 24">
                              <path d="M8 5v14l11-7z"></path>
                           </svg>
                        </span>
                        Watch Demo
                     </button>
                  </div>
	-->

    `;
  }



}
